import { render, staticRenderFns } from "./TrendyolKategori.vue?vue&type=template&id=72456c13&scoped=true&"
import script from "./TrendyolKategori.vue?vue&type=script&lang=js&"
export * from "./TrendyolKategori.vue?vue&type=script&lang=js&"
import style0 from "./TrendyolKategori.vue?vue&type=style&index=0&id=72456c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72456c13",
  null
  
)

export default component.exports